'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import CoreEngineDashboard from './components/CoreEngineDashboard';

export default function CoreEnginePage() {
  return (
    <AppLayout data-component-id="src/app/core-engine/page.tsx:9:4" data-component-path="src/app/core-engine/page.tsx" data-component-line="9" data-component-end-line="14" data-component-file="page.tsx" data-component-name="AppLayout" data-component-content="%7B%22elementName%22%3A%22AppLayout%22%7D"
      title="RTWO Core Engine"
      subtitle="Central execution pipeline — R1 through R7 orchestration"
    >
      <CoreEngineDashboard data-component-id="src/app/core-engine/page.tsx:13:6" data-component-path="src/app/core-engine/page.tsx" data-component-line="13" data-component-end-line="13" data-component-file="page.tsx" data-component-name="CoreEngineDashboard" data-component-content="%7B%22elementName%22%3A%22CoreEngineDashboard%22%7D" />
    </AppLayout>
  );
}
